import React, { useState, useRef, useEffect } from "react";

const AdditionalNotesSection = () => {
  const [additionalOpen, setAdditionalOpen] = useState(false);
  const additionalRef = useRef(null);
  const [additionalMaxHeight, setAdditionalMaxHeight] = useState("0px");

  // Keep the measured height for the additional notes section up-to-date
  useEffect(() => {
    if (!additionalRef.current) return;
    if (additionalOpen)
      setAdditionalMaxHeight(`${additionalRef.current.scrollHeight}px`);
    else setAdditionalMaxHeight("0px");
  }, [additionalOpen]);

  // Update additional notes height on resize
  useEffect(() => {
    const onResize = () => {
      if (additionalOpen && additionalRef.current)
        setAdditionalMaxHeight(`${additionalRef.current.scrollHeight}px`);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [additionalOpen]);

  return (
    <div className="mb-6">
      <div className="flex gap-x-2 items-center mb-[7px]">
        <img
          src="/images/NewUiIcons/addtionalnoteicon.svg"
          alt="Additional notes icon"
        />
        <p className="text-[#7876A1] text-[16px] font-semibold">
          Additional notes
        </p>
      </div>

      {/* Toggle button (arrow + text) - matches other sections */}
      <div className="mb-[8px] flex items-center gap-2 pl-[26px]">
        <button
          onClick={() => setAdditionalOpen((s) => !s)}
          aria-expanded={additionalOpen}
          className="flex items-center focus:outline-none"
        >
          <img
            src="/Vision Agent Icons/Back Arrow/ChevronLightPurple.svg"
            alt={additionalOpen ? "collapse details" : "expand details"}
            className={`w-3 h-3 transform transition-transform duration-300 ${
              additionalOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        <button
          onClick={() => setAdditionalOpen((s) => !s)}
          aria-expanded={additionalOpen}
          className="text-[#7876A1] text-[12px] font-medium focus:outline-none"
        >
          {additionalOpen ? "Hide details" : "Show details"}
        </button>
      </div>

      <div
        ref={additionalRef}
        className={`${
          additionalOpen ? "h-auto" : "h-0"
        } overflow-hidden transition-all duration-300`}
        style={{ maxHeight: additionalMaxHeight }}
      >
        <ul className="list-[square] space-y-4 text-[#211F59] text-[12px] pl-11">
          <li className="font-bold">
            <span className="font-semibold">Estimate &amp; billing:</span>
            <span className="font-normal ml-1">
              This is an estimate, you only pay for actual work and travel
              time (billed at the hourly rate).
            </span>
          </li>

          <li className="font-bold">
            <span className="font-semibold">If we finish early:</span>
            <span className="font-normal ml-1">You'll pay less than the estimate.</span>
          </li>

          <li className="font-bold">
            <span className="font-semibold">Cancellation:</span>
            <span className="font-normal ml-1">
              Free up to 24 hours before start; after that, a late-cancel fee
              may apply.
            </span>
          </li>

          <li className="font-bold">
            <span className="font-semibold">Payment hold:</span>
            <span className="font-normal ml-1">
              Clicking Book your move authorizes a temporary $1 card hold for
              verification.
            </span>
          </li>

          <li className="font-bold">
            <span className="font-semibold">Extra fees (no markup):</span>
            <span className="font-normal ml-1">
              Disposal/dumping, parking, tolls, extra packing materials, or
              other out-of-pocket costs are passed directly through on the
              final invoice.
            </span>
          </li>

          <li className="font-bold">
            <span className="font-semibold">Data use:</span>
            <span className="font-normal ml-1">
              We use your info only to schedule, dispatch, and support your
              move.
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdditionalNotesSection;
